// extracted by mini-css-extract-plugin
module.exports = {"reviewsList":"HVPppb"};